import { useQuery } from '@tanstack/react-query';

import FileProcessingApiHandler from 'app/services/fileProcessingApiHandler';

const DOWNLOAD_URL_STALE_TIME_MS = 5 * 60 * 1000;

const useFetchSavingsImageUrl = (imageId?: string, variant?: 'THUMBNAIL') =>
  useQuery({
    queryKey: ['savingsImageUrl', imageId, variant],
    queryFn: async () => {
      const response = await FileProcessingApiHandler.getSavingsImageUrl(
        imageId as string,
        variant
      );
      return (response as { url: string }).url;
    },
    enabled: !!imageId,
    staleTime: DOWNLOAD_URL_STALE_TIME_MS,
    retry: false,
  });

export default useFetchSavingsImageUrl;
